<template>
  <div class="knowledge-graph mb-30">
    <v-chart class="chart" :option="chartOption" autoresize v-if="show" />
    <div class="pieces_list mt-5 flex Flexalign Flexjustify">
      <div class="pieces_one flex Flexalign mr-10" v-for="(item, index) in piecesList" :key="index">
        <div class="piece_squre mr-5" :style="getBgColor(item.color)"></div>
        <div class="piece_label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { GraphChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  GraphChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  VisualMapComponent,
]);

export default {
  components: { VChart },
  data() {
    return {
      piecesList: [
        { color: '#FE997F', label: '0%~19%' },
        { color: '#FFBF66', label: '20%~39%' },
        { color: '#FFE25B', label: '40%~59%' },
        { color: '#CBE05B', label: '60%~79%' },
        { color: '#4ED5A7', label: '80%~100%' },
      ],
      show: true,
      chartOption: {
        // title: { text: "错题知识点图谱", left: "center" },
        tooltip: {
          formatter: (params) => {
            if (params.dataType === "node") {
              return `${params.name}<br/>掌握程度: ${params.value}%`;
            }
            return `${params.source} → ${params.target}`;
          },
        },
        legend: {
          data: ["知识点", "掌握程度区间"],
          bottom: 10,
        },
        visualMap: {
          type: "piecewise",
          pieces: [
            { min: 0, max: 19.999, label: "0%~19%" },
            { min: 20, max: 39.999, label: "20%~39%" },
            { min: 40, max: 59.999, label: "40%~59%" },
            { min: 60, max: 79.999, label: "60%~79%" },
            { min: 80, max: 100, label: "80%~100%" },
          ],
          inRange: {
            color: ["#FE997F", "#FFBF66", "#FFE25B", "#CBE05B", "#4ED5A7"],
          },
          orient: "horizontal",
          left: "center",
          bottom: -30,
          itemSymbol: "roundRect",
          textStyle: { fontSize: 12 },
        },
        series: [
          {
            type: "graph",
            layout: "force",
            force: { repulsion: 300, edgeLength: 200 },
            roam: true,
            draggable: true,
            symbolSize: 50,
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [4, 10],
            label: {
              show: true, position: "inside", formatter: "{b}", textStyle: {
                color: '#fff'   // 设置文字颜色为白色
              }
            },
            lineStyle: { color: "source", curveness: 0.3 },
            emphasis: { scale: true, lineStyle: { width: 3 } },
            data: [
              // { name: "周期现象", value: 0, category: 0, symbolSize: 60 },
              // { name: "角与弧度互化", value: 45, category: 0 },
              // { name: "任意角概念", value: 30, category: 0 },
              // { name: "终边相同的角", value: 75, category: 1, symbolSize: 55 },
              // { name: "弧度制", value: 0, category: 1 },
              // { name: "象限角", value: 15, category: 1 },
              // { name: "确定角位置", value: 25, category: 1 },
              // {
              //   name: "未关联资源",
              //   value: 5,
              //   category: 2,
              //   symbol: "diamond",
              //   symbolSize: 40,
              //   itemStyle: { color: "#999" },
              // },
            ],
            // links: [
            //   { source: "周期现象", target: "角与弧度互化" },
            // //   { source: "角与弧度互化", target: "周期现象" },
            //   { source: "周期现象", target: "任意角概念" },
            //   { source: "终边相同的角", target: "弧度制" },
            //   { source: "终边相同的角", target: "象限角" },
            //   { source: "终边相同的角", target: "确定角位置" },
            //   { source: "角与弧度互化", target: "未关联资源" },
            //   { source: "象限角", target: "未关联资源" }
            // ],
            categories: [
              { name: "周期知识点" },
              { name: "终边知识点" },
              { name: "特殊节点" },
            ],
          },
        ],
      },
    };
  },
  methods: {
    getBgColor(color) {
      return `background-color:${color}`
    }
  }
};
</script>

<style scoped lang="scss">
.knowledge-graph {
  width: 100%;
  height: 700px;
}

.chart {
  width: 100%;
  height: 100%;
}

.pieces_list {
  .pieces_one {
    .piece_squre {
      width: 24px;
      height: 16px;
      border-radius: 5px;
    }

    .piece_label {
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>